module.exports = __webpack_public_path__ + "static/img/cop_sch_logo5.771cd2ce.png";